import NoInlineResultSearcher from "./NoInlineResultSearchers"

class LoCSimplifiedSearcher extends NoInlineResultSearcher {
    key = 'LoC';
    searcherName = 'Library of Congress';
    infoText = "Books and other material from the digitized part of the LOC catalog";
    unsupportedTypeFilters = ["Datasets"]
    multiTypeFilterSupported = false;
    dateFilterSupported = true;
    typeFilter2urlSection = {"All types": {middleSection : "search", suffix : ""},
                            "Audio": {middleSection : "audio", suffix : ""},
                            "Books": {middleSection : "books", suffix : ""},
                            "Images": {middleSection : "photos", suffix : ""},
                            "Legislation / Government publications": {middleSection : "search", suffix : "&fa=original-format:Legislation / Government publications"},
                            "Manuscripts": {middleSection : "manuscripts", suffix : ""},
                            "Maps": {middleSection : "maps", suffix : ""},
                            "Notated music" : {middleSection : "notated-music", suffix : ""},
                            "Newspapers" : {middleSection : "newspapers", suffix : ""},
                            "Periodicals" : {middleSection : "search", suffix : "&fa=original-format:periodical"},
                            "Personal Narratives" : {middleSection : "search", suffix : "&fa=original-format:personal+narrative"},
                            "Software" : {middleSection : "search", suffix : "&fa=original-format:software,+e-resource"},
                            "Web Pages" : {middleSection : "search", suffix : "&fa=original-format:web+page"},
                            "Archived websites" : {middleSection : "web-archives", suffix : ""},
                            "Video" : {middleSection : "film-and-videos", suffix : ""},
    

    }
    iframeSupported = false;

    fillTargetWebsiteUrl(value, store) { 
    
        this.targetWebsiteUrl = "https://www.loc.gov/" + 
                                this.typeFilter2urlSection[store.searchInput.selectedTypes[0]]['middleSection'] + 
                                "/?q=" + 
                                encodeURIComponent(value) + 
                                this.typeFilter2urlSection[store.searchInput.selectedTypes[0]]['suffix'] + 
                                (store.searchInput.dates === null ? "" : "&dates="+store.searchInput.dates[0]+"/"+store.searchInput.dates[1])

    }
};


class OskiCatSearcher extends NoInlineResultSearcher {
    key = 'oskiCat';
    searcherName = 'UC Berkeley libraries (OskiCat)';
    infoText = 'UC Berkeley libraries (OskiCat)';
    multiTypeFilterSupported = true;
    dateFilterSupported = true;
    typeFilter2urlSection = {"All types": {suffix : ""},
                                "Audio": {suffix : "&m=i&m=j"},
                                "Books": {suffix : "&j=m"},
                                "Images" : {suffix : "&m=k"},
                                "Legislation / Government publications": {suffix : "&g=f&g=l&g=s&g=i&g=m&g=c"},
                                "Manuscripts": {suffix : "&m=t"},
                                "Maps": {suffix : "m=e&m=f"},
                                "Notated music" : {suffix : "&m=d"},
                                "Newspapers" : {suffix : "&j=s"},
                                "Periodicals" : {suffix : "&j=sl"},
                                "Software" : {suffix : "&m=m"},
                                "Video" : {suffix : "&v=v*"}
                            }  
    iframeSupported = true; 
    fillTargetWebsiteUrl(value, store) { 
        
        
        this.targetWebsiteUrl = "http://oskicat.berkeley.edu/search/X?SEARCH=(" + 
                                encodeURIComponent(value) + 
                                ")&SORT=D&e=cr" + 
                                store.searchInput.selectedTypes.map(i => this.typeFilter2urlSection[i]['suffix']).join()+
                                (store.searchInput.dates === null ? "" : "&Da="+store.searchInput.dates[0]+"&Db="+store.searchInput.dates[1]);

    }
};

class StanfordSearcher extends NoInlineResultSearcher {
    key = 'stanford';
    searcherName = 'Stanford University';
    infoText = 'Stanford University';
    typeFilter2urlSection = {"All types": {suffix : ""},
                                "Audio": {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Sound+recording"},
                                "Books": {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Book"},
                                "Images": {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Image"},
                                "Legislation / Government publications": {suffix : "&f%5Bgenre_ssim%5D%5B%5D=Legislative+materials"},
                                "Manuscripts": {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Archive"},
                                "Maps": {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Map"},
                                "Notated music" : {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Music+score"},
                                "Newspapers" : {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Newspaper"},
                                "Periodicals" : {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Journal%2FPeriodical"},
                                "Software" : {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Software%2FMultimedia"},
                                "Web Pages" : {suffix : "&fa=original-format:web+page"},
                                "Archived websites" : {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Archived+website"},
                                "Datasets" : {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Dataset"},
                                "Video" : {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Video"}

                            }   
    multiTypeFilterSupported = true;
    dateFilterSupported = true;
    iframeSupported = false;

    fillTargetWebsiteUrl(value, store) { 
        
        this.targetWebsiteUrl = "https://searchworks.stanford.edu/catalog?q=" + 
                                encodeURIComponent(value) + 
                                "&f%5Baccess_facet%5D%5B%5D=Online" + 
                                store.searchInput.selectedTypes.map(i => this.typeFilter2urlSection[i]['suffix']).join() + 
                                (store.searchInput.dates === null ? "" : "&range%5Bpub_year_tisim%5D%5Bbegin%5D=" + store.searchInput.dates[0] + "&range%5Bpub_year_tisim%5D%5Bend%5D=" + store.searchInput.dates[1]);
        
        
    }
}; 

class PrincetonSearcher extends NoInlineResultSearcher {
    key = 'princeton';
    searcherName = 'Princeton University';
    infoText = 'Princeton University';
    typeFilter2urlSection = {"All types": {suffix : ""},
                                "Audio": {suffix : "&f%5Bformat%5D%5B%5D=Audio"},
                                "Books": {suffix : "f%5Bformat%5D%5B%5D=Book"},
                                "Images": {suffix : "&f%5Bformat%5D%5B%5D=Visual+material"},
                                "Manuscripts": {suffix : "&f%5Bformat%5D%5B%5D=Manuscript"},
                                "Maps": {suffix : "&f%5Bformat%5D%5B%5D=Map"},
                                "Notated music" : {suffix : "&f%5Bformat%5D%5B%5D=Musical+score"},
                                "Periodicals" : {suffix : "&f%5Bformat%5D%5B%5D=Journal"},
                                "Software" : {suffix : "&f%5Bformat_main_ssim%5D%5B%5D=Software%2FMultimedia"},
                                "Datasets" : {suffix : "&f%5Bformat%5D%5B%5D=Data+file"},
                                "Video" : {suffix : "&f%5Bformat%5D%5B%5D=Video"}
                            }
    multiTypeFilterSupported = true;
    dateFilterSupported = true;
    fillTargetWebsiteUrl(value, store) { 
        
        this.targetWebsiteUrl = "https://catalog.princeton.edu/catalog?q="  + 
        encodeURIComponent(value)+
        "&f%5Baccess_facet%5D%5B%5D=Online" + 
        store.searchInput.selectedTypes.map(i => this.typeFilter2urlSection[i]['suffix']).join() + 
        (store.searchInput.dates === null ? "" : "&range%5Bpub_date_start_sort%5D%5Bbegin%5D=" + store.searchInput.dates[0] + "&range%5Bpub_date_start_sort%5D%5Bend%5D=" + store.searchInput.dates[1])

    }
}
export {OskiCatSearcher, StanfordSearcher, PrincetonSearcher, LoCSimplifiedSearcher}